export const incomingInvoicesTh = {
  'incomingInvoices.zahlart.label': 'วิธีการชำระเงิน',
  'incomingInvoices.zahlart.hinweis': 'ใบแจ้งหนี้ขาเข้านี้ชำระด้วยวิธีใด — หากไม่เลือกจะไม่สามารถบันทึกว่าชำระแล้วได้',
  'incomingInvoices.zahlart.bitteWaehlen': 'กรุณาเลือก …',
  'incomingInvoices.zahlart.inaktiv': 'ปิดใช้งาน',
  'incomingInvoices.zahlart.keineVorhanden': 'ไม่มีวิธีการชำระเงิน',
  'incomingInvoices.zahlart.zurZahlartenpflege': 'ไปที่การตั้งค่าวิธีการชำระเงิน',
  'incomingInvoices.zahlart.fehlt': 'กรุณาเลือกวิธีการชำระเงิน',
  'incomingInvoices.zahlart.bankZuordnungAktiv': 'ใบแจ้งหนี้นี้ถูกจับคู่กับรายการชำระเงินทางธนาคารแล้ว กรุณายกเลิกการจับคู่ในหน้าการกระทบยอดการชำระเงินก่อน',
  'incomingInvoices.zahlart.bezahltMit': 'ชำระด้วย: {{name}}',
  'incomingInvoices.zahlart.nichtErfasst': 'ไม่ได้บันทึกวิธีการชำระเงิน',
  'incomingInvoices.zahlart.alleBereitsBezahlt': 'เอกสารที่เลือกทั้งหมดชำระแล้วหรือเก็บถาวรแล้ว',
};
